import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Divider } from '@mui/material';
import theme from '../theme';
import { TitleNormal, TitleNormalBold } from '../common-text';
import BTButton from './BTButton';
import DialogIconInfo from '../../assets/icons/dialog_icon_info.svg';
import DialogIconDanger from '../../assets/icons/dialog_icon_danger.svg';

interface BTDialogProps {
    open: boolean;
    onClose: () => void;
    title: string;
    message: string;
    confirmButtonTitle: string;
    cancelButtonTitle: string;
    icon: React.ReactNode; // 아이콘을 React 컴포넌트로 받음
    onConfirm?: () => void; // 확인 버튼 클릭 시
    onCancel?: () => void; // 취소 버튼 클릭 시
    isCaution: boolean;
}

const BTDialog: React.FC<BTDialogProps> = ({ open, onClose, title, message, confirmButtonTitle, cancelButtonTitle, icon, onConfirm = undefined, onCancel = undefined, isCaution = false }) => {
    const defaultIcon = <img src={isCaution ? DialogIconDanger : DialogIconInfo} alt="dialog icon" width={24} height={24} />;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <div style={{ display: 'flex', alignItems: 'center', minHeight: '24px' }}>
                    {/* 아이콘 크기 설정 */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {
                            icon
                                ? React.cloneElement(icon as React.ReactElement, { width: 24, height: 24 })
                                : defaultIcon
                        }
                    </div>
                    <TitleNormalBold fontSize={20} style={{
                        marginLeft: 8,
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        color: isCaution ? theme.colors.colorWarn : undefined
                    }}>
                        {title}
                    </TitleNormalBold>
                </div>
            </DialogTitle>
            <Divider style={{ marginLeft: '16px', marginRight: '16px', backgroundColor: isCaution ? theme.colors.colorWarn : theme.colors.DefaultTextColor }} />
            <DialogContent>
                <div style={{ width: '500px', minHeight: '120px' }}>
                    <TitleNormal style={{ color: isCaution ? theme.colors.colorWarn : undefined }}>{message}</TitleNormal>
                </div>
            </DialogContent>
            <DialogActions>
                {onConfirm && (
                    <div style={{ marginBottom: '4px' }}>
                        <BTButton
                            onClick={onConfirm}
                            color={isCaution ? theme.colors.colorWarn : theme.colors.bbTech}
                            textColor="white"
                            sx={{ borderRadius: '8px' }}
                        >
                            {confirmButtonTitle}
                        </BTButton>
                    </div>
                )}
                {onCancel && (
                    <div style={{ marginBottom: '4px' }}>
                        <BTButton onClick={onCancel} sx={{ borderRadius: '8px' }}>
                            {cancelButtonTitle}
                        </BTButton>
                    </div>
                )}
                <div style={{ width: '4px' }}></div>
            </DialogActions>
        </Dialog>
    );
};

export default BTDialog;
